import { Language, MagicWandType } from "@/types/__generated__/union-types"

export interface ChatMetadata {
  originalContent?: string
  aiFeatures?: AiFeatureKind[]
  autoTranslationOriginalContent?: string
  autoTranslationTranslatedContent?: string
  autoTranslationBackTranslatedContent?: string
  autoTranslationTargetLanguage?: Language
  autoTranslationFailed?: boolean
}

export type ChatMessageKind = "text" | "participantAdded" | "participantRemoved"

export type LiveTranslationView = {
  isLiveTranslationEnabled: boolean
  selectedTargetLanguage: Language | null
}

export interface SofiaChatMessage {
  id: string
  sentAt: Date
  content: string
  senderDisplayName: string
  role: ChatMessageRole
  type: ChatMessageKind
  acsSenderIdentity: string | null
  acsChatThreadId: string
  metadata?: ChatMetadata
  hasSentReadReceipt?: boolean
}

export interface ChatMessageGroup {
  id: number
  messages: SofiaChatMessage[]
}

export type ChatMessageRole = "doctor" | "patient" | "system"

export const CHAT_MESSAGE_SEPARATOR = {
  BREAK_LINE: "\n",
  SPACE: " ",
}

export type AiFeatureKind =
  | "GREETING"
  | "NEXT_BEST_QUESTION"
  | "TRANSLATE"
  | `MAGIC_WAND_${MagicWandType}`
  | "QUESTIONNAIRE_SUMMARIZER_CHAT"
  | "CHAT_CASE_SUMMARY_CONFIRMATION_MESSAGE"

export type AiTrackingMetadata = {
  id: string
  name: string
  previousText: string
  newText: string
  selectedItem?: string
  aiFeature?: AiFeatureKind
  fileHash?: string
  aiRequestDurationMs?: number
  aiAnonymizationRequestDurationMs?: number
  createdAt: string
}

export interface SendChatMessage {
  originalContent: string | null
  sendContent: string
  aiFeatures: AiFeatureKind[]
  aiTrackingMetadata: AiTrackingMetadata[] | null
}

export interface UnsentChatMessage {
  contentBeforeAiFeature: string | null
  sendContent: string
  aiFeatures: AiFeatureKind[]
  aiTrackingMetadata: AiTrackingMetadata[] | null
}

export const SCROLL_BOTTOM_THRESHOLD = -50
